import React, { useCallback } from 'react';
import ThirdLevelCategorySelector from '../../pageInside/ThirdLevelCategorySelector';
import LanguageSelector from '../../pageInside/LanguageSelector';
import ExpandableTextarea from '../../pageInside/ExpandableTextarea';
import ExpandableApplicationSection from '../../pageInside/ExpandableApplicationSection';
import ApplicationLinksEditor from '../../pageInside/applicationLinks/ApplicationLinksEditor';
import { validateApplicationLinks } from '../../../utils/applicationLinks';
import { tokenText } from './tokenText';
import { getEventRoleApplicationCategories } from '../../auth/apiRoleTokens';

export const emptyRequestApproval = () => ({
  categoryPublicIds: [],
  preferredLanguages: [],
  applicationAnswers: { aboutYourself: '', experience: '', motivation: '', additionalInformation: '' },
  socialLinks: [],
});

// Only "Tell us about yourself" is mandatory (same rule as the server's
// normalizeRequestApproval); Experience, the additional questions and the
// links are optional, but a half-filled link row must be fixed or removed.
export const isRequestApprovalComplete = application => Boolean(
  application?.categoryPublicIds?.length &&
  application?.preferredLanguages?.length &&
  application?.applicationAnswers?.aboutYourself?.trim() &&
  validateApplicationLinks(application?.socialLinks || []).valid
);

export default function RequestApprovalStep({ application, onChange, token, eventToken, infoSource }) {
  const t = tokenText(infoSource);
  const tr = (key, fallback) => infoSource?.laguangeElakay?.('roleChangeRequest', infoSource.languageAPI)?.[key] || fallback;
  const loadCategories = useCallback((_token, query) => getEventRoleApplicationCategories(eventToken, query), [eventToken]);
  const answers = { ...emptyRequestApproval().applicationAnswers, ...(application.applicationAnswers || {}) };
  const setAnswer = (key, value) => onChange({ ...application, applicationAnswers: { ...answers, [key]: value } });
  return <div className="role-request-choose event-request-approval">
    <section><h3>{t('selectCategories')}</h3><ThirdLevelCategorySelector token={token} infoSource={infoSource}
      selectedCategoryIds={application.categoryPublicIds} onSelectionChange={categoryPublicIds => onChange({ ...application, categoryPublicIds })}
      pageSize={12} paginationEnabled loadCategories={eventToken ? loadCategories : undefined} /></section>
    <section><LanguageSelector infoSource={infoSource} selectedCodes={application.preferredLanguages}
      onChange={preferredLanguages => onChange({ ...application, preferredLanguages })} title={t('preferredLanguages')} /></section>
    <section className="role-request-application"><h3>{t('applicationInformation')}</h3>
      <ExpandableTextarea id="event-about-me" label={t('aboutMe')} required value={answers.aboutYourself} onChange={value => setAnswer('aboutYourself', value)} />
      <ExpandableTextarea id="event-experience" label={t('experience')} value={answers.experience} onChange={value => setAnswer('experience', value)} />
      <ExpandableApplicationSection label={tr('addMoreInformation', 'Add more information (Optional)')} closeLabel={tr('hideAdditionalQuestions', 'Hide additional questions')}>
        <ExpandableTextarea id="event-motivation" label={t('motivation')} value={answers.motivation} onChange={value => setAnswer('motivation', value)} />
        <ExpandableTextarea id="event-additional" label={t('additionalInformation')} value={answers.additionalInformation} onChange={value => setAnswer('additionalInformation', value)} />
      </ExpandableApplicationSection>
      <ApplicationLinksEditor idPrefix="event-application-links" infoSource={infoSource} links={application.socialLinks || []} onChange={socialLinks => onChange({ ...application, socialLinks })} />
    </section>
  </div>;
}
